import { AnimatePresence, motion } from 'motion/react';
import { useMemo } from 'react';

import { useBroadcast } from './hooks/useBroadcast';
import { pictureParamsData } from './data';

import { Picture } from './components/Picture/Picture';
import { BgVideoCloud } from './components/BgVideoCloud/BgVideoCloud';
import { Airplane } from './components/Airplane/Airplane';

import styles from './App.module.css';

function App() {
  const { allMessages, currentState } = useBroadcast();

  const messagesByTag = useMemo(() => {
    const grouped = {};
    allMessages.forEach((msg) => {
      if (!grouped[msg.titrTag]) grouped[msg.titrTag] = [];
      grouped[msg.titrTag].push(msg);
    });
    return grouped;
  }, [allMessages]);

  return (
    <div className={styles.appWrapper}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className={styles.bgFullImg}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.7 }}
            exit={{ opacity: 0, transition: { delay: 0.5, duration: 0.7 } }}
          />
        )}
      </AnimatePresence>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className={styles.bgImg}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.7 }}
            exit={{ opacity: 0, transition: { delay: 0, duration: 0.7 } }}
          />
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className={styles.motionBlock}
            initial={{ opacity: 0, y: '100vh' }}
            animate={{ opacity: 1, y: '0' }}
            key={`${currentState}-pictures`}
            exit={{
              opacity: 0,
              y: '100vh',
              transition: { duration: 1, delay: 0.5 },
            }}
            transition={{ duration: 1 }}
          >
            {pictureParamsData.map((pic) => {
              const currentMessagesByTag = messagesByTag[pic.tag];
              // if (!currentMessagesByTag) {
              //   return null;
              // }
              return (
                <Picture
                  key={pic.tag}
                  currentMessagesByTag={currentMessagesByTag}
                  left={`${pic.left}rem`}
                  top={`${pic.top}rem`}
                  width={`${pic.width}rem`}
                  height={`${pic.height}rem`}
                  borderRadius={pic.borderRadius}
                />
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {currentState === 'S1' && <Airplane />}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {currentState === 'S1' && <BgVideoCloud />}
      </AnimatePresence>
    </div>
  );
}

export default App;
